/**
 * Mock Data: User Tier Overview
 * Mock data for user tier distribution
 *
 * Corresponds to Postman endpoint: GET /product/api/v1/dashboard/user-tiers
 */

import type { UserTiersData } from '../data/remote/response';

// Re-export types and constants from response module for backward compatibility
export type { UserTierDistributionItem, UserTiersData, TierBadgeStyle } from '../data/remote/response';
export { tierBadgeStyles, tierTooltipDotColors } from '../data/remote/response';

export const mockUserTierData: UserTiersData = {
  totalUsers: 17,
  distribution: [
    { tierCode: 'BRONZE', count: 4, percentage: 23.53 },
    { tierCode: 'SILVER', count: 6, percentage: 35.29 },
    { tierCode: 'GOLD', count: 5, percentage: 29.41 },
    { tierCode: 'PLATINUM', count: 2, percentage: 11.76 },
  ],
};
